// 全部保单接口
import request from '../request'

// 获取福利详情
const getFflDetilInfo = (data) => {
  return request.post('/api/ffl/getFflDetilInfo', data)
}
// 查询文件类型
const getFflFileType = (data) => {
  return request.post('/api/ffl/getFileType', data)
}
// 提交文件
const createFflClaims = (data) => {
  return request.post('/api/ffl/createIclaims', data)
}
// 查询已上传文件
const updateFflFileList = (data) => {
  return request.post('/api/ffl/updateFileList', data)
}
// 更新已上传文件
const updateFflFile = (data) => {
  return request.post('/api/ffl/updateFile', data)
}
// 查询补充文件列表
const getFflClaimAppFileList = (data) => {
  return request.post('/api/ffl/getClaimAppFileList', data)
}
// 取消发福利理赔
const cancelFflClaim = (data) => {
  return request.post('/api/ffl/claimCancel', data)
}
// 获取发福利理赔详情
const getFflNoticeOfClaim = (data) => {
  return request.post('/api/ffl/getNoticeOfClaim', data)
}
// 文件上传无需微信授权无需登录
const uploadFafuliFile = (data) => {
  return request.post('/api/api/uploadMedFile', data)
}
// 对象数组
export default {
  getFflDetilInfo,
  getFflFileType,
  createFflClaims,
  updateFflFileList,
  updateFflFile,
  getFflClaimAppFileList,
  cancelFflClaim,
  getFflNoticeOfClaim,
  uploadFafuliFile
}
